import logoImg from '@app/assets/logo.png'
import { authOptions } from '@app/lib/server'
import { Button, Center, Paper, Stack, useMantineTheme } from '@mantine/core'
import { GetServerSideProps, type NextPage } from 'next'
import Head from 'next/head'
import Image from 'next/image'
import { getServerSession } from 'next-auth/next'
import { signIn } from 'next-auth/react'
import { useCallback, useEffect } from 'react'
import { useRouter } from 'next/router'

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  const session = await getServerSession(req, res, authOptions)

  return session?.user?.id
    ? {
        redirect: {
          destination: '/dashboard',
          permanent: false
        }
      }
    : {
        props: {}
      }
}

const LoginPage: NextPage = () => {
  const theme = useMantineTheme()
  const router = useRouter()
  const cognitoSignin = useCallback(() => signIn('cognito'), [])

  useEffect(() => {
    if (router.query.sso) {
      cognitoSignin().catch(console.error)
    }
  }, [cognitoSignin, router.query.sso])

  if (router.query.sso) {
    return null
  }

  return (
    <Center
      bg={theme.colors['brand-dark-blue'][6]}
      h='100vh'
    >
      <Head>
        <title>DPP / Sign In</title>
      </Head>
      <Paper
        p='xl'
        radius='xl'
      >
        <Stack
          align='center'
          spacing='xl'
        >
          <Image
            alt='Logo'
            height={100}
            src={logoImg}
            priority
          />
          <Button
            color='brand-red'
            fullWidth
            onClick={cognitoSignin}
            radius='xl'
            size='lg'
          >
            Login
          </Button>
        </Stack>
      </Paper>
    </Center>
  )
}

export default LoginPage
